import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

import { QueryNames } from 'Hooks/api/queryNames'
import { useErrorReporter } from 'Hooks/useErrorReporter'

import { submitInvoicePayment, SubmitInvoicePaymentPayload } from 'Services/invoices/invoiceService'

import { AppNotification } from 'Utils/types/appNotification'

const formatPaymentErrorMessage = (message: string): string => {
  const prefix = 'Error creating payment:'

  if (message.startsWith(prefix)) {
    const errorDetails = message.substring(prefix.length).trim()
    return errorDetails || AppNotification.SubmitInvoicePaymentFailure
  }

  return AppNotification.SubmitInvoicePaymentFailure
}

export const useSubmitInvoicePaymentQuery = () => {
  const queryClient = useQueryClient()
  const reportError = useErrorReporter()

  return useMutation(
    [QueryNames.SubmitInvoicePayment],
    (payload: SubmitInvoicePaymentPayload) => {
      return submitInvoicePayment(payload)
    },
    {
      onSuccess: (response) => {
        if (response.success) {
          queryClient.invalidateQueries([QueryNames.GetInvoices])
          toast.success(AppNotification.SubmitInvoicePaymentSuccess)
        } else {
          const displayMessage = formatPaymentErrorMessage(response.message || '')
          toast.error(displayMessage)
        }
      },
      onError: (err: Error) => {
        reportError(`useSubmitInvoicePaymentQuery error: ${err.message}`)
      }
    }
  )
}
